import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import PropTypes from 'prop-types';
import styled, { useTheme } from 'styled-components';

import useLoginForward from '@ecp/common/src/hooks/useLoginForward';
import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import Badge from '@ecp/common/src/components/badge/Badge';
import ButtonUnstyled from '@ecp/common/src/components/unstyled/button/ButtonUnstyled';

import { userInfoState } from '@fo-recoil/common/user/atom';
import { useConfirmDialog } from '@fo-hooks/common/useModal';
import useSiteInfo from '@fo-hooks/common/useSiteInfo';

const GnbIconButton = React.forwardRef(
  (
    { iconType: Icon, badgeContent, label, selected, to, showZero, clickWhenLogout: onClickLogout, useDefaultColor },
    ref
  ) => {
    const { login } = useRecoilValue(userInfoState);
    const navigate = useNavigate();
    const theme = useTheme();
    const { siteNumber } = useSiteInfo();
    const { showConfirmDialog } = useConfirmDialog();
    const loginForward = useLoginForward(siteNumber, showConfirmDialog);

    const handleMoveClick = () => {

      if (!login && (!['/' , '/customer-service/notice', '/customer-service/faq', 'customer-service','/customer-service'].includes(to)) ) {
         loginForward();
      } else {
         navigate(`${to}`);
      }
   }

    const color = useMemo(
      () => ({
        icon: selected ? theme.color.icon.current : theme.color.icon.normal,
        label: selected ? theme.color.primary : theme.color.text.basic,
      }),
      [selected, theme.color.icon, theme.color.primary, theme.color.text.basic]
    );
    return (
      <ButtonUnstyled style={{ textDecoration: 'none' }} onClick={onClickLogout ? onClickLogout : handleMoveClick}>
        <Wrapper ref={ref}>
          <Badge
            badgeContent={badgeContent}
            position={{ top: theme.component.gnb.cart.top, right: theme.component.gnb.cart.right }}
            size={{ width: '16px', height: '16px' }}
            showZero={showZero}
          >
            <Icon
              fill={useDefaultColor ? undefined : color.icon}
              stroke={useDefaultColor ? undefined : color.icon}
              width={'20px'}
              height={'20px'}
            />
          </Badge>
          <Label color={useDefaultColor ? theme.color.text.basic : color.label}>{label}</Label>
        </Wrapper>
      </ButtonUnstyled>
    );
  }
);
export default GnbIconButton;

GnbIconButton.propTypes = {
  iconType: PropTypes.elementType,
  badgeContent: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.string,
  selected: PropTypes.bool,
  showZero: PropTypes.bool,
  to: PropTypes.string,
  clickWhenLogout: PropTypes.func,
  useDefaultColor: PropTypes.bool,
};

GnbIconButton.defaultProps = {
  selected: false,
  showZero: false,
};

GnbIconButton.displayName = 'GnbIconButton';

const Wrapper = styled(FlexBoxColumn)`
  width: fit-content;
  height: 36px;
  gap: 3px;
  cursor: pointer;
`;

const Label = styled.span.attrs(({ color, style }) => ({ style: { ...style, color } }))`
  font-size: 11px;
  line-height: 11px;
  font-weight: ${(props) => props.theme.font.weight.demiLight};
`;
